// Firebase configuration - Add your Firebase config here
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase config from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyANxaSfkrsOJL9t_WM19N5jx11A1jUXX08",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "ditris-web-ced62.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "ditris-web-ced62",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "ditris-web-ced62.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "979439363826",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:979439363826:web:bb1da016ab2e58302ad26b"
};

// Check if Firebase is configured
const isFirebaseConfigured = firebaseConfig.apiKey && 
                             firebaseConfig.projectId && 
                             firebaseConfig.appId;

// Initialize Firebase
let app;
let auth;
let db;
let storage;

if (isFirebaseConfigured) {
  try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);
    storage = getStorage(app);
    console.log('✅ Firebase initialized successfully');
  } catch (error) {
    console.error('❌ Firebase initialization error:', error);
    console.log('⚠️ Using mock data mode - Firebase credentials not configured');
  }
} else {
  console.log('⚠️ Firebase not configured - using mock data mode');
  console.log('📝 Add Firebase credentials to .env file to enable real database');
}

export { app, auth, db, storage, isFirebaseConfigured };